import EmberTooltipBase from 'ember-tooltips/components/ember-tooltip-base';
export default EmberTooltipBase.extend({
  _tooltipVariantClass: 'ember-tooltip'
});